let apiUrlEndpoint;
if (window.location.host.includes("bquick.co.il")) apiUrlEndpoint = "https://api.bquick.co.il/";
else apiUrlEndpoint = "http://localhost:4667/";

const apiUrlProtectedEndpoint = apiUrlEndpoint + "loggedin/";

const apiEndpoints = {
  // Copyright text
  CopyrightText: "© All Rights Reversed | Made With Love by ITAY for better Web ",
  apiUrlEndpoint,
  maxLengthOfTxtDesc: 100,
  maxMembersAllowedPerOffice: 30,
  refreshPendingMemberNotification: 60 * 1000 * 20, // refresh every 20 mins

  // Links/endpoints
  // unprotected
  addPendingUserEndpoint: apiUrlEndpoint + "unprotected/add-pending-user",
  loginUserEndpoint: apiUrlEndpoint + "unprotected/login",
  confEmailEndpoint: apiUrlEndpoint + "unprotected/conf-email",
  resendEmailConfEndpoint: apiUrlEndpoint + "unprotected/resend-email-conf",
  resetUserPassEndpoint: apiUrlEndpoint + "unprotected/reset-pass",
  changeUserPassEndpoint: apiUrlEndpoint + "unprotected/change-pass",
  getPublicFieldsEndpoint: apiUrlEndpoint + "unprotected/get-fields",
  clientFillsDataEndpoint: apiUrlEndpoint + "unprotected/client-fills-data",
  // protected
  // User
  getUserExtendedDataEndpoint: apiUrlProtectedEndpoint + "user/get-data-extended",
  // updateUserDataEndpoint: apiUrlProtectedEndpoint + "user/update-user-data",
  getTabsEndpoint: apiUrlProtectedEndpoint + "user/get-tabs",
  getDocsInfoAndFieldsEndpoint: apiUrlProtectedEndpoint + "user/docs-info-with-tags",
  generateDocsEndpoint: apiUrlProtectedEndpoint + "user/generate-docs",
  saveFieldsEndpoint: apiUrlProtectedEndpoint + "user/save-deal-fields",
  addNewDealEndpoint: apiUrlProtectedEndpoint + "user/new-deal",
  updateDealEndpoint: apiUrlProtectedEndpoint + "user/update-deal",
  getAllDealsEndpoint: apiUrlProtectedEndpoint + "user/get-all-deal",
  // dealNewCommentEndpoint: apiUrlProtectedEndpoint + "user/deal-new-comment",
  letClientFillData: apiUrlProtectedEndpoint + "user/client-fill-data",
  getFieldsWithDataEndpoint: apiUrlProtectedEndpoint + "user/fields-with-data-info",
  getNotificationsEndopint: apiUrlProtectedEndpoint + "user/get-notifications",
  rejectNotificationEndpoint: apiUrlProtectedEndpoint + "user/reject-notification",
  approveNotificationEditsEndpoint: apiUrlProtectedEndpoint + "user/approve-notification-edits",

  // payment
  getPaymentTokenEndpoint: apiUrlProtectedEndpoint + "payment/get-payment-token",
  executePaymentEndpoint: apiUrlProtectedEndpoint + "payment/execute-payment",
  //sales tracking
  // sales
  getSalesAccountsListEndpoint: apiUrlProtectedEndpoint + "sales/get-sales-accounts-list",
  setSalesmanOwningUsersEndpoint: apiUrlProtectedEndpoint + "sales/set-salesman-owning-users",
  getSalesAccActivityEndpoint: apiUrlProtectedEndpoint + "sales/get-sales-acc-activity",

  //product states
  getClientProductStatesEndpoint: apiUrlProtectedEndpoint + "sales/get-client-product-states",
  getAllProductStatesEndpoint: apiUrlProtectedEndpoint + "sales/get-all-product-states",
  addProductStateEndpoint: apiUrlProtectedEndpoint + "sales/add-product-state",
  editProductStateTypeEndpoint: apiUrlProtectedEndpoint + "sales/edit-product-state-type",
  deleteProductStateTypeEndpoint: apiUrlProtectedEndpoint + "sales/delete-product-state-type",
  deleteProductStateEndpoint: apiUrlProtectedEndpoint + "sales/delete-product-state",

  //users
  logUserOutEndpoint: apiUrlProtectedEndpoint + "sales/user-logout",
  adminUpdateUserDataEndpoint: apiUrlProtectedEndpoint + "sales/admin-update-user-data",

  //user cards
  getSimilarCardsEndpoint: apiUrlProtectedEndpoint + "sales/get-similar-cards",
  deleteUserCardEndpoint: apiUrlProtectedEndpoint + "sales/delete-user-card",

  //members
  adminGetMembersDataEndpoint: apiUrlProtectedEndpoint + "sales/admin-get-members-data",
  transferMemberToOtherCardEndpoint: apiUrlProtectedEndpoint + "sales/transfer-member-other-card",
  addNewMemberFromCardEndpoint: apiUrlProtectedEndpoint + "sales/new-member-from-card",
  adminMemberActionEndpoint: apiUrlProtectedEndpoint + "sales/admin-member-action",
  initMemberReconfEndpoint: apiUrlProtectedEndpoint + "sales/init-member-reconf",

  //memberships
  getEndingMembershipsEndpoint: apiUrlProtectedEndpoint + "sales/get-ending-memberships",

  //assignments
  salesListAndAssignmentsEndpoint: apiUrlProtectedEndpoint + "sales/sales-list-and-assignments",
  getFutureAssignmentsSalesUserEndpoint: apiUrlProtectedEndpoint + "sales/get-future-assignments-sales-user",

  //allowed users
  getAllowedUsersEndpoint: apiUrlProtectedEndpoint + "sales/get-allowed-users",
  addAllowedUserEndpoint: apiUrlProtectedEndpoint + "sales/add-allowed-user",
  updateAllowedUserEndpoint: apiUrlProtectedEndpoint + "sales/update-allowed-user",
  deleteAllowedUserEndpoint: apiUrlProtectedEndpoint + "sales/delete-allowed-user",

  //user comments
  adminUpdateUserCommentEndpoint: apiUrlProtectedEndpoint + "sales/admin-update-user-comment",
  adminUpdateUserCommentLabelEndpoint: apiUrlProtectedEndpoint + "sales/admin-update-user-comment-label",

  //pending users
  getPendingUsersEndpoint: apiUrlProtectedEndpoint + "sales/get-pending-users",
  handlePendingUserEndpoint: apiUrlProtectedEndpoint + "sales/handle-pending-user",

  //search
  getUsersSearchKeyEndpoint: apiUrlProtectedEndpoint + "sales/get-users-search-key",
  getUsersSearchByTypesKeyEndpoint: apiUrlProtectedEndpoint + "sales/get-users-search-by-types",

  // AWS Operations
  generatePresignedUploadUrl: apiUrlProtectedEndpoint + "aws/generate-upload-url",

  //excel
  getExcelFileUsersSearchTypesEndpoint: apiUrlProtectedEndpoint + "sales/get-users-search-by-types-for-excel",

  //suppot cases
  getCardSupportCasesEndpoint: apiUrlProtectedEndpoint + "sales/get-card-support-cases",
  getAllOpenSupportCasesEndpoint: apiUrlProtectedEndpoint + "sales/get-all-open-support-cases",
  pushNewSupportEndpoint: apiUrlProtectedEndpoint + "sales/push-new-support",
  updateSupportEndpoint: apiUrlProtectedEndpoint + "sales/update-support-case",

  //work stations
  resetStationsEndpoint: apiUrlProtectedEndpoint + "sales/reset-stations",

  //courses
  uploadEpisodesEndpoint: apiUrlProtectedEndpoint + "sales/upload-videos",
  updateEpisodeEndpoint: apiUrlProtectedEndpoint + "sales/update-video",
  getCourseVideosEndpoint: apiUrlProtectedEndpoint + "sales/get-course-videos",
  getCoursesEndpoint: apiUrlProtectedEndpoint + "sales/get-courses",
  addCourseEndpoint: apiUrlProtectedEndpoint + "sales/add-course",
  updateCourseEndpoint: apiUrlProtectedEndpoint + "sales/update-course",
  deleteCourseEndpoint: apiUrlProtectedEndpoint + "sales/delete-course",
  deleteEpisodeEndpoint: apiUrlProtectedEndpoint + "sales/delete-episode",

  findEpisodeByIdEndpoint: apiUrlEndpoint + "allow-watch-video/episode-by-id",

  // system Tech
  updateFileEndpoint: apiUrlProtectedEndpoint + "system-tech/update-file-data",
  setDocDeletedEndpoint: apiUrlProtectedEndpoint + "system-tech/set-doc-deleted",
  testDocEndpoint: apiUrlProtectedEndpoint + "system-tech/test-doc",
  updateFieldEndpoint: apiUrlProtectedEndpoint + "system-tech/update-field",
  newFieldEndpoint: apiUrlProtectedEndpoint + "system-tech/new-field",
  addOrRemoveFieldFromDocEndpoint: apiUrlProtectedEndpoint + "system-tech/add-or-remove-field-doc",
  getFieldsAdminEndpoint: apiUrlProtectedEndpoint + "system-tech/all-fields-data"
};

export default apiEndpoints;
